module.exports = __webpack_public_path__ + "static/media/bg_whatsapp.020cab69.png";